import { render, staticRenderFns } from "./MyQuotationDetailGeneralInfo.vue?vue&type=template&id=0e1e523a&scoped=true&"
import script from "./MyQuotationDetailGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./MyQuotationDetailGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotationDetailGeneralInfo.vue?vue&type=style&index=0&id=0e1e523a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1e523a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1e523a')) {
      api.createRecord('0e1e523a', component.options)
    } else {
      api.reload('0e1e523a', component.options)
    }
    module.hot.accept("./MyQuotationDetailGeneralInfo.vue?vue&type=template&id=0e1e523a&scoped=true&", function () {
      api.rerender('0e1e523a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationDetailGeneralInfo.vue"
export default component.exports